import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuComponent } from './menu/menu.component';
import {vssProviders} from '../../vss.providers';
import {NzLayoutModule} from 'ng-zorro-antd/layout';
import {NzPopoverModule} from 'ng-zorro-antd/popover';
import {NzAvatarModule} from 'ng-zorro-antd/avatar';
import {NzIconModule} from 'ng-zorro-antd/icon';
import {NzButtonModule} from 'ng-zorro-antd/button';
import {NzMenuModule} from 'ng-zorro-antd/menu';
import {NzToolTipModule} from 'ng-zorro-antd/tooltip';
import {UploadModule} from '../upload/upload.module';
import {PermissionModule} from '../permission/permission.module';
import {ImageModule} from '../image/image.module';
import {PipeModule} from '../pipe/pipe.module';


@NgModule({
  declarations: [
    MenuComponent
  ],
  exports: [MenuComponent],
    imports: [
        CommonModule,
        NzLayoutModule,
        NzPopoverModule,
        NzAvatarModule,
        NzIconModule,
        NzButtonModule,
        NzMenuModule,
        NzToolTipModule,
        UploadModule,
        PermissionModule,
        ImageModule,
        PipeModule
    ],
  providers: [...vssProviders]
})
export class MenuModule { }
